import React from 'react';
import cn from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import UserCoreBadge from '../_partials/UserCoreBadge';
import UserSymbol from '../_partials/UserSymbol';
import { getUserSymbol, getUserTypeId } from '../helpers';
import { useTranslation } from 'react-i18next';
import s from './BasicUserName.scss';
export const BasicUserName = /*#__PURE__*/ React.memo(({ user, showSymbol = true, symbolOpensPopup, symbolClassName, useCoreRibbon, usernameClassName, coreRibbonClassname, withOwnerText })=>{
    var _user_coreInfo, _user_coreInfo1;
    const isCoreUser = ((_user_coreInfo = user.coreInfo) === null || _user_coreInfo === void 0 ? void 0 : _user_coreInfo.level) !== undefined;
    const showCoreBadge = isCoreUser && showSymbol && useCoreRibbon;
    const { t } = useTranslation();
    const username = withOwnerText ? `${user.username} ${t('user.identity.owner.concat')}` : user.username;
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            typeid: getUserTypeId(user),
            itemid: user.userId
        }
    }, /*#__PURE__*/ React.createElement("span", {
        className: usernameClassName !== null && usernameClassName !== void 0 ? usernameClassName : s['data-hook-wrapper']
    }, username), showCoreBadge && /*#__PURE__*/ React.createElement(UserCoreBadge, {
        corePackage: (_user_coreInfo1 = user.coreInfo) === null || _user_coreInfo1 === void 0 ? void 0 : _user_coreInfo1.level,
        size: "large",
        className: cn(s['core-badge'], symbolClassName, coreRibbonClassname),
        openUserSymbolPopup: symbolOpensPopup
    }), showSymbol && !showCoreBadge && /*#__PURE__*/ React.createElement(UserSymbol, {
        userSymbol: getUserSymbol(user),
        className: symbolClassName,
        openUserSymbolPopup: symbolOpensPopup
    }));
});
BasicUserName.displayName = 'BasicUserName';
export default BasicUserName;
